/**
 * Product version shown in the app shell.
 * SoT is the monorepo root package.json `version`, injected at Vite build time
 * as `import.meta.env.VITE_SGRC_VERSION`.
 */

export function resolveSgrcAppVersion(env = typeof import.meta !== "undefined" ? import.meta.env : {}) {
  const raw = typeof env?.VITE_SGRC_VERSION === "string" ? env.VITE_SGRC_VERSION.trim() : "";
  return raw;
}

export function formatSgrcAppVersionLabel(version) {
  const raw = String(version || "").trim();
  if (!raw) return "";
  return /^v/i.test(raw) ? raw : `v${raw}`;
}
